// Uniform card wrapper so every dashboard chart gets the same frame,
// header layout and a fixed canvas height (keeps rows aligned and
// stops pie/doughnut charts from auto-sizing huge).
const ChartCard = ({ title, subtitle, action, footer, height = 320, children }) => (
  <div className="chart-card">
    <div className="chart-card__header">
      <div>
        <h5 className="chart-card__title">{title}</h5>
        {subtitle && <p className="chart-card__subtitle">{subtitle}</p>}
      </div>
      {action && <div className="chart-card__action">{action}</div>}
    </div>
    <div className="chart-card__canvas" style={{ height }}>
      {children}
    </div>
    {footer && <div className="chart-card__footer">{footer}</div>}
  </div>
);

export default ChartCard;
